import Aos from "aos";
import "aos/dist/aos.css";

const Slide = () =>{
    Aos.init({
        duration: 3000
    })
};

export default Slide